import React from "react"
import H1 from "./Utility/heading1"

export default props => (
    <div class={`intro ${props.introClass}`} style={{ backgroundImage: `url(${props.bgImage})` }}>
        <H1 headingText1={props.headingText1} headingColor1={props.headingColor1} />
        <p class="body" style={{ color: props.bodyColor }}>{props.bodyText}</p>
    </div>
)